import { render, staticRenderFns } from "./FaultReport.vue?vue&type=template&id=48c4bf4a"
import script from "./FaultReport.vue?vue&type=script&lang=js"
export * from "./FaultReport.vue?vue&type=script&lang=js"
import style0 from "./FaultReport.vue?vue&type=style&index=0&id=48c4bf4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports